import { Component, OnInit } from '@angular/core';
import { FeedbackService } from '../../services/feedback.service';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';



@Component({
  selector: 'app-fedratingdet',
  templateUrl: './fedratingdet.component.html',
  styleUrls: ['./fedratingdet.component.scss'],
    providers:[FeedbackService]
})
export class FedratingdetComponent implements OnInit {

  
         ddlfeed=[];
         memberdetails:any[]=[];
         classdetails:any[]=[];
         closeResult: string;
         fedopts:any[]=[];
        
         student:boolean=true;
         staff:boolean=false;
         memberdash:any={};
         objfedhead:any={};
         objquesthead:any={};
         objquestopt:any={};
         selfed:any='0';
         objdetl:any={};
         modalOptions:NgbModalOptions;
         arrquest=[];
         arrdetails=[];
         private modalRef: NgbModalRef;
         arrstatus=[{value:'Active'},{value:'Inactive'}];
         constructor(private http: HttpClient, private liservice: FeedbackService,private router: Router,private route: ActivatedRoute) { }
       
        
       
       
         ngOnInit(): void {
           
          //  this.getmemberdetails('selstu','');
          //  this.getclassdetails();
          //  this.memberdashcnts('dashcnts');
          this.readinparams();
          
          
         }
       
         private readinparams()
    {

      this.route.params.subscribe(params => {
        console.log("params",params);
        var emid=params['emid'];
        var fdid=params['fdid'];
        var suid=params['suid'];
        this.getfedbackhead(fdid,emid,suid);
       
       
      });
    }
         getfedbackhead(fbid,emid,suid) {
           this.liservice.getstfdetrating(fbid,emid,suid)
               .subscribe(
               resultArray => {
                   console.log('members-result', resultArray);
                    this.objdetl = resultArray.stfsum;
                   this.memberdetails = resultArray.qtdetls;
                   this.arrquest = resultArray.arrprrate;
    
                  
                   
               },
               error => console.log("Error :: " + error)
               )
         }
  

         calculateWidth(num): string {
  return num+'%';
}
   generateStarRatingHTML(rating: number, maxRating: number = 5): string {
    let starsHtml = '';
    // const fullStar = '<span style="color:green" class="fa fa-star fachecked"></span>';
    // const emptyStar = '<span style="color:green" class="fa fa-star-o"></span>';
    // const halfStar = '<span style="color:green" class="fa fa-star-half-o fachecked"></span>'; // Requires Font Awesome v5+
  
    const fullStar = "<span style='color:green' class='fa fa-star fachecked fa-size'></span>";
    const emptyStar = "<span style='color:green' class='fa fa-star-o fa-size'></span>";
    const halfStar = "<span style='color:green' class='fa fa-star-half-o fachecked fa-size'></span>"; // Requires Font Awesome v5+
    const roundedRating = Math.round(rating * 2) / 2; // Round to nearest 0.5
  
    for (let i = 1; i <= maxRating; i++) {
      if (i <= roundedRating) {
        starsHtml += fullStar;
      } else if (i - 0.5 === roundedRating) {
        starsHtml += halfStar;
      } else {
        starsHtml += emptyStar;
      }
    }
    // console.log('rating',starsHtml);
    return starsHtml;
    
  }
  
       
       
        
       }
    
  
